import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Link from 'next/link';
import { styled } from '@classify/react-core-components/styles';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DateRangeIcon from '@mui/icons-material/DateRange';
import GroupIcon from '@mui/icons-material/Group';
import PaymentsIcon from '@mui/icons-material/Payments';
import { ROUTES } from '@openclassrooms/routing';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import Button from '@classify/react-core-components/Button';
import { translate } from '@openclassrooms/translations';
import UpvIcon from './UvpIcon';
const Title = styled('h3')(({
  theme: {
    palette,
    spacing
  }
}) => ({
  borderBottom: `1px solid ${palette.divider}`,
  paddingBottom: spacing(1)
}));
const ListItem = styled('li')(({
  theme: {
    typography,
    breakpoints,
    spacing
  }
}) => ({
  fontWeight: typography.fontWeightMedium,
  marginBottom: spacing(1),
  [breakpoints.up('sm')]: {
    overflow: 'hidden',
    marginBottom: 0
  }
}));
const List = styled('ul')(({
  theme: {
    spacing,
    breakpoints
  }
}) => ({
  margin: spacing(2, 'auto'),
  [breakpoints.up('sm')]: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    rowGap: spacing(2),
    columnGap: spacing(3),
    padding: 0,
    listStyle: 'none'
  },
  [breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(4, auto)'
  }
}));
const ItemIcon = styled('span')(({
  theme: {
    breakpoints,
    spacing
  }
}) => ({
  display: 'none',
  [breakpoints.up('sm')]: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    marginRight: spacing(1)
  }
}));
export interface Props {
  children?: ReactNode;
}
const PathBanner = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="h3" component={Title}>{translate("course_home.path_promo.title")}</Typography>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography variant="body" component="p" sx={{
      mt: 2
    }}>{translate("course_home.path_promo.text")}</Typography>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Typography variant="body" component={ListItem}><ItemIcon><UpvIcon icon={PaymentsIcon} /></ItemIcon>{translate("free_user.offer_diploma.intro.uvp1")}</Typography>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography variant="body" component={ListItem}><ItemIcon><UpvIcon icon={DateRangeIcon} /></ItemIcon>{translate("free_user.offer_diploma.intro.uvp2")}</Typography>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Typography variant="body" component={ListItem}><ItemIcon><UpvIcon icon={AssignmentIcon} /></ItemIcon>{translate("free_user.offer_diploma.intro.uvp3")}</Typography>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <List>{t3}{t4}{t5}<Typography variant="body" component={ListItem}><ItemIcon><UpvIcon icon={GroupIcon} /></ItemIcon>{translate("free_user.offer_diploma.intro.uvp4")}</Typography></List>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      marginTop: 2,
      marginBottom: 4
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Box sx={t7}><Button variant="secondary" data-event="Navigation|Redirection::Internal|Path suggestion Apply" rel="nofollow" component={Link} href={`${ROUTES.APPLICATION.WELCOME}?appsource=generic`}>{translate("global.apply.cta")}</Button></Box>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== children) {
    t9 = <>{t1}{t2}{t6}{t8}{children}</>;
    $[8] = children;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
};
export default PathBanner;